import { VerticalAlignTopRounded } from '@mui/icons-material';
import { useEffect, useState } from 'react';
import * as S from './styles';

export function BackToTopButton() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleScroll = () => setShow(window.scrollY > 200);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!show) return null;

  return (
    <S.BackToTop
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
      <VerticalAlignTopRounded
        color="primary"
        style={{ fontSize: 28 }}
        id="id-searchPartsCancelled-btn-backToTop"
      />
    </S.BackToTop>
  );
}